import { render, staticRenderFns } from "./Regest.vue?vue&type=template&id=595a164a"
import script from "./Regest.vue?vue&type=script&lang=js"
export * from "./Regest.vue?vue&type=script&lang=js"
import style0 from "./Regest.vue?vue&type=style&index=0&id=595a164a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports